import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getGlimsCommCodes(mode, spras, zecdgrp) {
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/mode/${mode}/spras/${spras}/glims?zecdgrp=${zecdgrp}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/prtRptCustCodeLists`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPprNoPopupList({ pprNoPopupSearch, pprNoPagingInfo }) {
		let queryStr = '';
		// let pprNo = pprNoPopupSearch.pprNo;
		// if (searchParams.pprNo !== undefined) {
		queryStr = objectToQueryString({
			partNo: pprNoPopupSearch.partNo,
			partNm: pprNoPopupSearch.partNm,
			pprNo: pprNoPopupSearch.pprNo,
			cofCd: pprNoPopupSearch.cofCd,
			cofNm: pprNoPopupSearch.cofNm,
			currentPage: pprNoPagingInfo.currentPage,
			pageUnit: pprNoPagingInfo.pageUnit
		});
		// }
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/pprNos${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPrtRptList({ searchParams, pagingInfo,isAuth }) {
		let queryStr = '';
		let pprNo = searchParams.pprNo;
		// if (searchParams.pprNo !== undefined) {
		queryStr = objectToQueryString({
			pprNo,
			partNo: searchParams.partNo,
			partNm: searchParams.partNm,
			pgsStCd: searchParams.pgsStCd,
			cofCd: searchParams.cofCd,
			strDt: searchParams.strDt,
			endDt: searchParams.endDt,
			partGCd: searchParams.partGCd,
			isAuth:isAuth,
			currentPage: pagingInfo.currentPage,
			pageUnit: pagingInfo.pageUnit
		});
		// }
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/rpts${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPrtRptInfo(params) {
		let queryStr = '';
		let pprNo = params.pprNo;
		// pprNo = '123';
		// if (searchParams.pprNo !== undefined) {
		queryStr = objectToQueryString({
			pprNo: pprNo, //불량보고번호
			partNo: params.partNo, //품번
			ckuNo: params.ckuNo, //검사번호
			overSrgNo: params.overSrgNo //OS&D 번호
		});

		// }
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/pprNo/${pprNo}/rptInfo${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPartMstInfo(params) {
		const isGbn = params.gbn;
		const partNo = params.rowData.partNo; //품번
		const ckuNo = params.rowData.ckuNo; //검사번호
		const overSrgNo = params.rowData.overSrgNo; //OS&D 번호

		let queryStr = `?isGbn=${isGbn}&partNo=${partNo}&ckuNo=${ckuNo}&overSrgNo=${overSrgNo}`;

		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/partNo/${partNo}/mst${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//입력한 Form데이터 저장
	async saveData(param, pprNo) {
		try {
			let url = `${BASE_URL}/pqy/pcku/prtRpt/v1/status/1`;
			if (pprNo !== undefined && pprNo !== '' && pprNo !== null) {
				url = `${BASE_URL}/pqy/pcku/prtRpt/v1/status/2/pprNo/${pprNo}`;
			}

			const response = await client.post(url, param, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 메일발송
	async sendMail({ sendData }) {
		try {
			//let url = `${BASE_URL}/comm/common/mailSend/v1/status/1/send`;
			let url = `${BASE_URL}/pqy/pcku/prtRpt/v1/status/1/pprNo/${sendData.pprNo}/mailSend`;
			const response = await client.post(url, sendData);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/* 결함유형 레벨 1 */
	async getBadTypeCodeLv1List(dForm) {
		let queryStr = '';
		let response = '';
		try {
			// if (dForm.partGCd === 'KD') {
			// 	await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/badTypeCdLv1s`);
			// } else {
			queryStr = objectToQueryString({
				partGCd: dForm.partGCd
			});
			response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/badTypeCdLv1s${queryStr}`);
			// }

			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/* 결함유형 레벨 2 */
	async getBadTypeCodeLv2List({ code, partGCd }) {
		let badType1 = code;
		let response = '';
		try {
			// if (partGCd === 'KD') {
			// 	response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/badType1/${badType1}/badTypeCdLv2s`);
			// } else {
			let queryStr = objectToQueryString({
				partGCd: partGCd
			});
			response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/badType1/${badType1}/badTypeCdLv2s${queryStr}`);
			// }

			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/* 결함유형 레벨 3 */
	async getBadTypeCodeLv3List({ code, partGCd }) {
		let badType2 = code;
		let response = '';
		try {
			// if (partGCd === 'KD') {
			// response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/badType2/${badType2}/badTypeCdLv3s`);
			// } else {
			let queryStr = objectToQueryString({
				partGCd: partGCd
			});
			response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/badType2/${badType2}/badTypeCdLv3s${queryStr}`);
			// }
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//파일 다운로드 관련fileDownloadGlims
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//Glims파일 다운로드 관련
	async fileDownloadGlims(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFileGlims`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownloadGlimsHmcErp(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/glimsFileDownloadHmCErp`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 승인 프로세스 수행
	async saveState(stateParams) {
		try {
			const response = await client.post(
				`${BASE_URL}/pqy/pcku/prtRpt/v1/status/2/pprNo/${stateParams.pprNo}/affrPrcsId/${stateParams.affrPrcsId}/pgsStCd/${stateParams.pgsStCd}`,
				stateParams
			);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 승인 프로세스 수행
	async saveState2({ formData, pprNo, affrPrcsId, pgsStCd }) {
		try {
			let url = `${BASE_URL}/pqy/pcku/prtRpt/v1/status/3/pprNo/${pprNo}/affrPrcsId/${affrPrcsId}/pgsStCd/${pgsStCd}`;
			const response = await client.post(url, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 불량보고서 삭제
	async deletePrtRpt(delParams) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/prtRpt/v1/status/3/pprNo/${delParams.pprNo}`, delParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 회신
	async answer({ formData, pprNo }) {
		// try {
		// 	const response = await client.post(`${BASE_URL}/pqy/pcku/prtRpt/v1/status/2/pprNo/${answerParams.pprNo}/answer`, answerParams);
		// 	return response?.data || null;
		// } catch (error) {
		// 	throw error.response?.data;
		// }
		try {
			let url = `${BASE_URL}/pqy/pcku/prtRpt/v1/status/2/pprNo/${pprNo}/answer`;
			const response = await client.post(url, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},

	// 개선이력
	async getPrtRptHisList({ historyPagingInfo, partNo, affrPrcsId }) {
		let queryStr = '';
		queryStr = objectToQueryString({
			partNo: partNo,
			affrPrcsId: affrPrcsId,
			currentPage: historyPagingInfo.currentPage,
			pageUnit: historyPagingInfo.pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/prtRpt/v1/partNo/${partNo}/rptHis${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
